module.exports = __webpack_public_path__ + "img/tim-mossholder.02d69d66.jpg";